import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgWizardService } from "ng-wizard";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { TargetAchievementModel } from "../../shared/models/target-achievement";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { TargetAchievementProvider } from "../../shared/providers/target-achivement.provider";

@Component({
  selector: "app-list-target-achievements",
  templateUrl: "./list-target-achievements.component.html",
  styleUrls: ["./list-target-achievements.component.scss"],
})
export class ListTargetAchievementsComponent implements OnInit {
  targetAchievments: TargetAchievementModel[];
  formGroup;
  getPaginationCount;
  addOrEditCampaign: any;
  deletePopupUiData;
  submitted: boolean = false;
  constructor(
    public targetAchivementProvider: TargetAchievementProvider,
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public adminDataProvider: AdminDataProvider,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    public alertService: AlertService
  ) { }

  ngOnInit() { }

  ngDoCheck() {
    this.targetAchievments = this.targetAchivementProvider.targetAchievments;
    this.getPaginationCount = this.targetAchivementProvider.getPaginationCount;
  }

  editTarget(item: TargetAchievementModel) {
    this.router.navigate(["/hubAdmin/add-target-achievements"], {
      queryParams: { targetId: item.id },
    });
  }

  addTarget() {
    this.router.navigate(["/hubAdmin/add-target-achievements"]);
  }

  paginationClick(e) {
    console.log(e);
    this.targetAchivementProvider.page = e;
    this.targetAchivementProvider.getTargetAchievementList();
  }

  deleteTarget(targetModal, item: TargetAchievementModel) {
    this.addOrEditCampaign = "delete";
    this.deletePopupUiData = item.target_title;
    this.formGroup = this.fb.group({
      id: item.id,
      program_id: 1,
    });
    this.showTargetModal(targetModal);
  }

  showTargetModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  onSubmitTarget(formData) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.addOrEditCampaign == "delete") {
      formData.status = 0;
      this.targetAchivementProvider.updateTarget(formData);
      this.modalService.dismissAll();
    }
    this.submitted = false;
  }

  changeStatus(item: TargetAchievementModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.updateTargetAchivement + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
